import Vue from "vue";
import PaginaService from "../domain/web/PaginaService";
import SwalMessage from "../domain/message/SwalMessage";

function initialState() {
  return {
    collapsed: false,
    items: []
  };
}

const formatMenu = (publicoId, state) => {
  const paginaService = new PaginaService(Vue.http);

  return paginaService
    .getPaginasMenuByPublico(publicoId, state)
    .then(menus => {
      let arr = [];

      for (let menu of menus) {
        let items = [];
        let categorias = [];
        for (let pagina of menu.paginaGrupo) {
          let infoPagina = pagina.infoPagina;
          let categoriaPaginaGrupo = pagina.categoriaPaginaGrupo;

          let url = infoPagina.url;
          let urlInterno = infoPagina.url.split("interno").length == 1;
          let urlHttp = infoPagina.url.split("http").length == 1;
          let urlHttps = infoPagina.url.split("https").length == 1;
          if (urlInterno && urlHttp && urlHttps) {
            url = `${process.env.INTERNO_URL}${infoPagina.url}`;
          }

          const loginPortal = infoPagina.url.split("login-portal-integrado");
          if (loginPortal.length > 1) {
            url = `${loginPortal[loginPortal.length - 1]}`;
          }

          let item = {
            enabled: true,
            url,
            icon: infoPagina.icone,
            nome: infoPagina.titulo
          };

          if (categoriaPaginaGrupo.length > 0) {
            for (let categoria of categoriaPaginaGrupo) {
              let categoriaPagina = categoria.categoriaPagina;
              if (!categorias.hasOwnProperty(categoriaPagina.id)) {
                categorias = {
                  ...categorias,
                  [categoriaPagina.id]: {
                    enabled: true,
                    icon: categoriaPagina.icone,
                    nome: categoriaPagina.nome,
                    items: []
                  }
                };
              }
              categorias[categoriaPagina.id].items = [
                ...categorias[categoriaPagina.id].items,
                item
              ];
            }
          } else {
            items = [...items, item];
          }
        }

        items = [...items, {"categorias": categorias}];

        arr = [
          ...arr,
          {
            title: menu.titulo,
            items
          }
        ];
      }
      return arr;
    })
    .catch(err => {
      console.log(err.message);
      SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
    });
};

const mutations = {
  updateMenu(state, items) {
    state.items = items;
  },
  collapseMenu(state, collapsed) {
    state.collapsed = collapsed;
  }
};

const actions = {
  loadMenu(state, publicoId) {
    formatMenu(publicoId, state).then(menus => {
      state.commit("updateMenu", menus);
    });
  },
  setMenu(state, items) {
    state.commit("updateMenu", items);
  },
  toogleMenu(state, collapsed) {
    state.commit("collapseMenu", collapsed);
  }
};

const namespaced = true;

const menu = {
  namespaced,
  state: initialState(),
  actions,
  mutations
};

export default menu;



// WEBPACK FOOTER //
// ./src/store/menu.js